import { css } from '@/styled-system/css';

export const styledUsersPageStyles = css({
  '&-add-button': {
    textAlign: 'right',
  },
  '& .full-width': {
    width: '100%',
  },
  '& .UsersPage-SubNav': {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'bg.neutral.base',
    padding: 0,
    margin: 0,
    maxWidth: 'inherit',
  },
  '& .Badge': {
    marginLeft: '8px',
  },
  '&-add-user-icon': {
    marginRight: '8px',
  },
  '& .empty-message': {
    textAlign: 'center',
    padding: '30px 0',
  },
});
